module.exports = __webpack_public_path__ + "static/img/Update0814.98771d8f.png";